import React from 'react';

const InfoFilledIcon = ({ width = 20, height = 22, color = '#667085', iconColor = 'white', ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}>
      <g clipPath="url(#clip0_1129_26815)">
        <path
          d="M4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16Z"
          fill={color}
        />
        <path
          d="M17.5 20.5C17.5 20.6989 17.421 20.8897 17.2803 21.0303C17.1397 21.171 16.9489 21.25 16.75 21.25C16.3522 21.25 15.9706 21.092 15.6893 20.8107C15.408 20.5294 15.25 20.1478 15.25 19.75V16C15.0511 16 14.8603 15.921 14.7197 15.7803C14.579 15.6397 14.5 15.4489 14.5 15.25C14.5 15.0511 14.579 14.8603 14.7197 14.7197C14.8603 14.579 15.0511 14.5 15.25 14.5C15.6478 14.5 16.0294 14.658 16.3107 14.9393C16.592 15.2206 16.75 15.6022 16.75 16V19.75C16.9489 19.75 17.1397 19.829 17.2803 19.9697C17.421 20.1103 17.5 20.3011 17.5 20.5ZM14.5 11.875C14.5 11.6525 14.566 11.435 14.6896 11.25C14.8132 11.065 14.9889 10.9208 15.1945 10.8356C15.4 10.7505 15.6262 10.7282 15.8445 10.7716C16.0627 10.815 16.2632 10.9222 16.4205 11.0795C16.5778 11.2368 16.685 11.4373 16.7284 11.6555C16.7718 11.8738 16.7495 12.1 16.6644 12.3055C16.5792 12.5111 16.435 12.6868 16.25 12.8104C16.065 12.934 15.8475 13 15.625 13C15.3266 13 15.0405 12.8815 14.8295 12.6705C14.6185 12.4595 14.5 12.1734 14.5 11.875Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1129_26815">
          <path
            d="M4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16Z"
            fill={iconColor}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.forwardRef(InfoFilledIcon);
